/**
 * YMM filter accessibility: inject visible labels for Year/Make/Model selects
 * when the snippet markup doesn't include them (e.g. cached or AJAX-inserted HTML).
 * Runs on load and when facet-filters content is replaced.
 */
(function() {
  var sel = '.ymm-filter select.jsYMMSelect';
  var labels = { year: 'Year', make: 'Make', model: 'Model' };

  function ensureYmmFilterLabels() {
    document.querySelectorAll(sel).forEach(function(select) {
      var wrapper = select.closest('.ymm-filter');
      if (!wrapper || wrapper.querySelector('.ymm-filter__label')) return;
      var name = (select.getAttribute('name') || (select.id || '').replace(/^ymm-/, '') || '').toLowerCase();
      var labelText = labels[name] || (name.charAt(0).toUpperCase() + name.slice(1));
      var id = select.id || 'ymm-' + name + '-' + Math.random().toString(36).slice(2, 9);
      if (!select.id) select.id = id;
      var label = document.createElement('label');
      label.setAttribute('for', id);
      label.className = 'ymm-filter__label';
      label.textContent = labelText;
      wrapper.classList.add('ymm-filter--labeled');
      select.after(label);
    });
    document.querySelectorAll(sel).forEach(function(select) {
      var w = select.closest('.ymm-filter');
      if (w) w.classList.toggle('is-filled', select.value !== '');
    });
  }

  window.ensureYmmFilterLabels = ensureYmmFilterLabels;

  function run() {
    ensureYmmFilterLabels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 100);
  setTimeout(run, 500);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      var shouldRun = mutations.some(function(m) {
        return m.addedNodes.length && Array.from(m.addedNodes).some(function(n) {
          return n.nodeType === 1 && (n.querySelector && n.querySelector(sel) || n.matches && n.matches(sel) || n.classList && n.classList.contains('ymm-filter'));
        });
      });
      if (shouldRun) setTimeout(run, 0);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
